import { SButton } from '@strana-artw/ui-kit';
export default {
  name: 'ChangePasswordSuccess',
  components: {
    SButton: SButton
  },
  methods: {
    close: function close() {
      this.$modal.close();
    }
  }
};